export const isProdEnvironment = (): boolean => {
  const PROD_REGEX = new RegExp("^prod", "i");
  return PROD_REGEX.test(window?.__RUNTIME_ENV__?.ENVIRONMENT);
};
